export default function authHeader() {
  const token = localStorage.getItem('noone-wallet-token');

  if (token) {
    return { Authorization: 'Bearer ' + token };
  } else {
    return {};
  }
}